import * as React from "react";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Box, Grid, Skeleton } from "@mui/material";
import { ApiService } from "@/app/services/AppService";
import {
  BasicProgram,
  BasicProgramType,
  ResponseObject,
  ViewDetailsServices,
} from "@/app/classes/main";
import ViewDetails from "./ViewDetails";
import { CardRsOneService } from "../card/CardRsOneService";
import "./index.css";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ViewDetailsRsOneContainerProps {
  open: any;
  handleCloseStoreDialog: any;
  viewDetailsRsOneSid: any;
}

interface ViewDetailsRsOne {
  ViewDetailsServices: ViewDetailsServices;
}

const ViewDetailsRsOneContainer: React.FC<ViewDetailsRsOneContainerProps> = ({
  open,
  handleCloseStoreDialog,
  viewDetailsRsOneSid,
}) => {
  const sid = viewDetailsRsOneSid ?? "";
  const [oneRsServiceData, setOneRsServiceData] = useState<
    ViewDetailsRsOne[] | undefined
  >(undefined);
  const apiService = React.useMemo(() => new ApiService(), []);
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(new ViewDetailsServices());
  const [updateFlag, setUpdateFlag] = useState(false);
  const [updateCard, setUpdateCard] = useState(false);

  const handleViewDetails = (basicProgram: ViewDetailsServices) => {
    setOpenViewDetails(true);
    setUpdateFlag(true);
    setViewDetails(basicProgram);
  };

  const handleClose = () => {
    handleCloseStoreDialog();
    // setOneRsServiceData([]);
  };

  const getOneRsPackages = React.useCallback(async () => {
    try {
      if (sid) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.getServicesInOneRs + "id=" + sid
          );
        const serviceDataOneRs = responseObject?.object;
        setOneRsServiceData(serviceDataOneRs);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, sid]);

  useEffect(() => {
    getOneRsPackages();
  }, [sid, getOneRsPackages]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        closeAfterTransition={false}
      >
        <Box
          sx={{
            width: "-webkit-fill-available",
            textAlign: "end",
            padding: "0.5rem 0.5rem 0px 0px",
          }}
        >
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ cursor: "pointer", color: "black" }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            background: "#fff",
          }}
        >
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
              color: "black",
              margin: "0rem auto",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "black",
                padding: "0px 1rem",
                fontWeight: "bold",
                fontSize: { xs: "16px", sm: "24px" },
              }}
            >
              Choose any one service from below to avail the @Re. 1 service
              offer below!
            </Typography>
          </Box>
        </Box>
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            background: "#fff",
            padding: {
              xs: "4px 4px 5rem",
              sm: "1rem 1rem 4rem",
              md: "2rem 2rem 4rem",
            },
            display: "flex",
            margin: "auto",
          }}
        >
          {oneRsServiceData && oneRsServiceData.length > 0
            ? oneRsServiceData &&
              oneRsServiceData?.map((item: any, index: any) => (
                <Grid container item xs={12} sm={6} md={4} lg={2.5} key={index}>
                  <CardRsOneService
                    childId={item?.id}
                    cid={item?.cid}
                    item={item}
                    viewDetailsData={() => handleViewDetails(item)}
                    updateCard={updateCard}
                    setUpdateCard={() => setUpdateCard(false)}
                  />
                </Grid>
              ))
            : Array.from({ length: 4 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  sx={{
                    margin: { xs: "0.5rem auto", sm: "1rem" },
                    width: { xs: "280px", sm: "280px", md: "280px" },
                    height: { xs: "280px", sm: "320px", md: "320px" },
                  }}
                />
              ))}
        </Grid>
      </Dialog>
      <ViewDetails
        open={openViewDetails}
        setClose={() => setOpenViewDetails(false)}
        id={viewDetails?.id}
        cid={viewDetails?.cid}
        imageUrl={viewDetails?.coverImage?.secureHttpPath}
        heading={viewDetails?.name}
        servicedDetails={viewDetails?.aboutList}
        descriptions={viewDetails?.descriptions}
        amount={viewDetails?.amount}
        min={viewDetails?.min}
        subHeading={viewDetails?.subHeading}
        mrp={viewDetails?.mrp}
        specialPrice={viewDetails?.specialPrice}
        specialMessage={viewDetails?.specialMessage}
        coin={viewDetails?.cashbackSalontymCoins}
        aboutList={viewDetails?.aboutList}
        serviceCharge={viewDetails?.serviceCharge}
        productCost={viewDetails?.productCost}
        reloadCartItemsFlag={() => setUpdateCard(true)}
        setReloadViewDetailsItem={() => setUpdateFlag(false)}
        reloadViewDetailsItem={updateFlag}
      />
    </React.Fragment>
  );
};

export default ViewDetailsRsOneContainer;
